export function appointmentAnalytics(state = [], action) {
  switch (action.type) {
    case "APPOINTMENT_ANALYTICS_FETCH_DATA_SUCCESS":
      return action.appointmentAnalytics;
    default:
      return state;
  }
}
